<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Genel Bilgiler
        </template>
        <b-card>
          <b-row>
            <b-col
              cols="12"
              md="12"
            >
              <product-categories-category-select />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <product-categories-title />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <product-categories-summary />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <product-categories-content />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <product-categories-ordering />
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <product-categories-image-card />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Seo Bilgileri
        </template>
        <seo-component data-store="productCategories/dataItem" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'
import SeoComponent from '@/layouts/components/common/SeoComponent.vue'
import ProductCategoriesTitle from '@/views/Admin/ProductCategories/Elements/Title.vue'
import ProductCategoriesSummary from '@/views/Admin/ProductCategories/Elements/Summary.vue'
import ProductCategoriesContent from '@/views/Admin/ProductCategories/Elements/Content.vue'
import ProductCategoriesOrdering from '@/views/Admin/ProductCategories/Elements/Ordering.vue'
import ProductCategoriesImageCard from '@/views/Admin/ProductCategories/Elements/ImageCard.vue'
import ProductCategoriesCategorySelect from '@/views/Admin/ProductCategories/Elements/CategorySelect.vue'

export default {
  name: 'ProductCategoriesItemForm',
  components: {
    ProductCategoriesCategorySelect,
    ProductCategoriesImageCard,
    ProductCategoriesOrdering,
    ProductCategoriesContent,
    ProductCategoriesSummary,
    ProductCategoriesTitle,
    BCard,
    BRow,
    BCol,
    BTabs,
    BTab,
    SeoComponent,
  },
  computed: {
    itemData() {
      return this.$store.getters['productCategories/dataItem']
    },
  },
}
</script>
